import {
  Button,
  Icon,
  IconProps,
  Popover,
  SpaceBetween,
  StatusIndicator,
} from '@cloudscape-design/components';
import { Box } from '@cloudscape-design/components';
import { Container } from '@cloudscape-design/components';
import { StatisticStatus } from '../common/types';

export type StatisticBoxProps = {
  statistic: number | string;
  percentile: number;
  status: StatisticStatus;
  details?: React.ReactNode;
  icon: IconProps.Name;
  label: string;
};

export function StatisticBox(props: StatisticBoxProps) {
  const { statistic, percentile, status, icon, label, details } = props;

  const indicatorContent =
    status === 'extremely-low' ? (
      <StatusIndicator type="error">Extremely Low</StatusIndicator>
    ) : status === 'below-average' ? (
      <StatusIndicator type="warning">Below Average</StatusIndicator>
    ) : status === 'above-average' ? (
      <div className="flex flex-row items-center justify-center gap-2">
        <StatusIndicator type="success">Above Average</StatusIndicator>
      </div>
    ) : (
      <StatusIndicator type="info">Average</StatusIndicator>
    );

  return (
    <Container
      header={
        <Box variant="p" fontSize="heading-s" textAlign="center">
          <Icon name={icon} size="inherit" /> {label}
        </Box>
      }
      fitHeight
      footer={
        <Box variant="div" fontSize="heading-s" textAlign="center">
          <div className="flex flex-row items-center justify-center gap-2">
            <Popover
              position="bottom"
              size="small"
              triggerType="text"
              header={label}
              content={
                <Box variant="p" textAlign="center">
                  Better than {(100 * percentile).toFixed(1)}% of similar businesses
                </Box>
              }
            >
              {indicatorContent}
            </Popover>
          </div>
        </Box>
      }
    >
      <div className="flex flex-col items-center justify-center h-full">
        <Box variant="p" textAlign="center" fontWeight="heavy" fontSize="heading-xl">
          {statistic}
        </Box>
        {details && (
          <Box variant="p" textAlign="center" fontSize="heading-s">
            {details}
          </Box>
        )}
      </div>
    </Container>
  );
}
